import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { InputField, Textarea } from 'src/components/UI'
import { CrewDataMutateType } from 'src/types'

export const AddressInfo = () => {


    const { t } = useTranslation()

    const { register, formState: { errors } } = useFormContext<CrewDataMutateType>()

    const errorGenertor = (key: keyof CrewDataMutateType) => ({ error: !!errors?.[key], errorText: errors?.[key]?.message })

    const errorText = (title: string) => `${title} ${t('IsRequired')}`


    return (
        <div className='flex flex-col  gap-4 bg-white p-4 rounded-lg border '>

            <span className='font-semibold'>{t('AddressInfo')}</span>

            <div className='grid grid-cols-1 lg:grid-cols-2 gap-6'>

                <div className='col-span-1 order-1 lg:order-1'>

                    <Textarea
                        label={t('Address')}
                        {...register('home_address', { required: { value: true, message: errorText(t('family')) } })}
                        {...errorGenertor('home_address')}
                    />
                </div>

                <div className='col-span-1 order-2 lg:order-3'>

                    <InputField
                        label={t('phone')}
                        {...register('phone', { required: { value: false, message: errorText(t('phone')) } })}
                        {...errorGenertor('phone')}
                        type='tel'

                    />
                </div>

                {/* <div className='col-span-1 order-3 lg:order-2'>

                    <Textarea
                        label={t('workAddress')}
                        {...register('work_address', { required: { value: false, message: errorText(t('work_address')) } })}
                        {...errorGenertor('work_address')}
                    />
                </div>

                <div className='col-span-1 order-4 lg:order-4'>

                    <InputField
                        label={t('WorkPhone')}
                        {...register('work_phone', { required: { value: false, message: errorText(t('work_phone')) } })}
                        {...errorGenertor('work_phone')}
                        type='tel'

                    />
                </div> */}


            </div>
        </div>
    )
}
